// extracted by mini-css-extract-plugin
module.exports = {"hero":"extra-money--hero--347P0","content":"extra-money--content--B--WA"};